import styled from 'styled-components';

const BannerHeaderStyle = styled.div`
	--distanceLine: var(--sp2x);
	--paddingBannerTB: var(--sp1-5x);
	--paddingBannerLR: 0;
	--distancePhone: var(--sp1x);
	--sizeIcon: var(--sp2-5x);

	.wrapper-contact {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: var(--headerBannerHeight);
		min-height: var(--headerBannerHeight);
		overflow: hidden;
		clip-path: inset(0 0 100% 0 round 0px);
		z-index: 10;
		background: linear-gradient(0deg, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0.2) 100%),
			linear-gradient(90deg, #b700e6 -4.75%, #ff0086 83.99%);
		display: flex;
		justify-content: center;
		align-items: center;

		.line-horizontal {
			width: 2px !important;
			height: calc(var(--sizeIcon) + var(--paddingBannerTB) / 2);
			background-color: var(--mainColor);
			border-radius: 999px;
			margin: 0 var(--distanceLine);
		}

		.wrapper-inner-content {
			min-height: var(--headerBannerHeight);
			height: auto;
			display: flex;
			align-items: center;
			width: fit-content;
			will-change: transform;
			user-select: none;
			-webkit-user-select: none;
			gap: var(--sp2-5x);

			.wrapper-content-contact {
				display: flex;
				justify-content: center;
				align-items: center;
				padding: var(--paddingBannerTB) var(--paddingBannerLR);
				height: fit-content;
				white-space: nowrap;
			}
		}
	}

	.phone {
		display: flex;
		align-items: center;
	}

	.phone-icon {
		margin-right: var(--distancePhone);
		font-size: var(--sizeIcon);
		height: fit-content;
		animation: shake 3s ease infinite;
	}

	.phone-text {
		border-bottom: 1px solid var(--mainColor);
	}

	@keyframes shake {
		0%,
		50%,
		100% {
			transform: rotateZ(0deg);
		}
		5% {
			transform: rotateZ(-15deg);
		}
		10% {
			transform: rotateZ(15deg);
		}
		15% {
			transform: rotateZ(-10deg);
		}
		20% {
			transform: rotateZ(10deg);
		}
		25% {
			transform: rotateZ(-5deg);
		}
		30% {
			transform: rotateZ(5deg);
		}
		35% {
			transform: rotateZ(-2deg);
		}
	}

	@keyframes marquee {
		to {
			transform: translateX(-50%);
		}
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--paddingBannerTB: var(--sp1x);
	}
	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
	}
	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--sizeIcon: var(--sp2x);
	}
	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
	}
	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
	}
	/* //! Mobile — marquee banner */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--distanceLine: var(--sp1x);

		.wrapper-contact {
			justify-content: start;
		}

		/* gap: 0 + padding-right per copy = seamless -50% loop */
		.wrapper-contact .wrapper-inner-content {
			gap: 0;
			animation: marquee 12s linear infinite;
		}

		.wrapper-contact .wrapper-inner-content .wrapper-content-contact {
			padding-right: var(--sp2-5x);
		}
	}
`;

export default BannerHeaderStyle;
